export default __webpack_public_path__ + "static/media/cart.fb1b7cfa.svg";